import { render, staticRenderFns } from "./ActionItem.vue?vue&type=template&id=2ed690a1&"
import script from "./ActionItem.vue?vue&type=script&lang=js&"
export * from "./ActionItem.vue?vue&type=script&lang=js&"
import style0 from "./ActionItem.vue?vue&type=style&index=0&id=2ed690a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports